// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ExampleEndpointSuccessResponse = {
    body: (value) => {
        return {
            value: value,
            type: "body",
            _visit: function (visitor) {
                return FernIr.ExampleEndpointSuccessResponse._visit(this, visitor);
            },
        };
    },
    stream: (value) => {
        return {
            value: value,
            type: "stream",
            _visit: function (visitor) {
                return FernIr.ExampleEndpointSuccessResponse._visit(this, visitor);
            },
        };
    },
    sse: (value) => {
        return {
            value: value,
            type: "sse",
            _visit: function (visitor) {
                return FernIr.ExampleEndpointSuccessResponse._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "body":
                return visitor.body(value.value);
            case "stream":
                return visitor.stream(value.value);
            case "sse":
                return visitor.sse(value.value);
            default:
                return visitor._other(value);
        }
    },
};
